/**
 * 西班牙语（es）
 */
export default {
  Components: {
    ShoppingCart: {
      Tips1: 'Seleccione productos en el mismo almacén para realizar un pedido.',
      ShipFrom: 'Nave de',
      Delete: 'Borrar',
      ProductHasBeenDiscontinued: 'El producto ha sido descontinuado',
      Tips2: '¿Estás seguro de eliminar este artículo?',
      Tips3: '¡Tu bolsa de compras está vacía!',
      SoldOut: 'Agotado',
      Total: 'Total',
      ShippingCalculation: 'Cálculo de envío',
      Tips4: 'La bolsa de compras tiene',
      Tips5: '3 almacenes',
      Tips6: 'de productos',
      Tips7: 'Puede elegir productos del mismo almacén para calcular el flete por usted',
      ShippingTo: 'Embarcar hacia',
      Select: 'seleccionar',
      ShippingMehod: 'Método de envío',
      Description: 'Descripción',
      Qty: 'Cantidad',
      UnitPrice: 'Precio unitario',
      Weight: 'Peso',
      Tips8: 'Seleccionar productos en el mismo almacén para realizar un pedido',
      Submit: 'Entregar'
    },
    SelectStoreToPublish: {
      Tips1: 'Selecciona la tienda a publicar',
      Tips2: 'Lista para almacenar',
      Platform: 'Plataforma',
      Store: 'Almacenar',
      Cancel: 'Cancelar',
      Submit: 'Entregar',
      AllowStoreBinding: 'Permitir enlace de tienda',
      NOStoreFound: 'NO se encontró ninguna tienda',
      ConnectANewStore: 'Conectar una nueva tienda',
      SP: 'SP',
      Shopify: 'Shopify',
      Tips3: 'Seleccione una plataforma',
      Tips4: 'Por favor seleccione una tienda'
    },
    QianHai: {
      title: 'Tarjeta de crédito',
      CreditCard: 'Tarjeta de crédito'
    },
    Product: {
      SoldOut: 'Agotado',
      New: 'Nuevo',
      Sales: 'Ventas',
      LoginHint: 'Regístrese en Kakaclo para desbloquear el precio mayorista',
      DetailHint: 'No se pudieron obtener los detalles del producto, comuníquese con el equipo de servicio al cliente'
    },
    NewFunction: {
      Notification: 'Notificación',
      Events: 'Eventos',
      SoldOutList: 'Lista agotada',
      ExportList: 'Lista de exportación',
      UpdateTime: 'tiempo de actualizacion'
    },
    InformBox: {
      Notification: 'Notificación',
      Events: 'Eventos',
      SoldOutList: 'Lista agotada',
      ExportList: 'Lista de exportación',
      NoRecordsFound: 'No se encontraron registros',
      ViewAll: 'Ver todo'
    },
    HelpCenter: {
      Tutorial: 'Tutorial',
      Tips1: 'Tutorial de KakaClo: 1-Conecte KakaClo a Shopify',
      YouTubeVideoPlayer: 'reproductor de videos de youtube',
      Tips2: 'R. Para conectar su tienda Shopify, haga clic en los botones "Pedido" o "Producto" en la esquina superior derecha para acceder a su backend.',
      Tips3: 'Tutorial de KakaClo: 2- ¿Cómo encontrar y enumerar productos en KakaClo?',
      Tips4: 'En esta sección, aprenderá:',
      Tips5: '1. Cómo encontrar los productos que quieres vender de KakaClo',
      Tips6: '2. Cómo publicar productos en tu tienda Shopify.',
      Tips7: '3. Cómo realizar cambios en las fotos, variaciones y precios de su producto.',
      Tips8: 'Tutorial de KakaClo: 3- ¿Cómo editar tu pedido?',
      Tips9: 'Haga clic en el botón "Pedido" para acceder a todos los pedidos que se realizan en su backend.',
      Tips10: 'En esta página, hay 4 tipos principales de estado para un pedido: En espera de pago, Pendiente, En tránsito y En reembolso.',
      HelpCenter: 'Centro de ayuda'
    },
    CardDialog: {
      AddCard: 'Agregar tarjeta',
      SecurityCode: 'Código de seguridad',
      CardNo: 'Número de tarjeta',
      ExpireDate: 'Fecha de caducidad',
      BillingAddress: 'Dirección de Envio',
      FullName: 'Nombre completo',
      PhoneNumber: 'Número de teléfono',
      StreetAddressLine1: 'Dirección (Línea 1',
      StreetAddressLine2: 'Dirección de calle Linea 2',
      City: 'Ciudad',
      StateProvinceRegion: 'Estado / Provincia / Región',
      Country: 'País',
      ZipCode: 'Código postal',
      InputContent: 'Contenido de entrada',
      Cancel: 'Cancelar',
      Submit: 'Entregar'
    },
    Airwallex: {
      Airwallex: 'Airwallex'
    },
    AccountSettingDialog: {
      Tips1: 'Puedes reenviar el código después',
      Tips2: 's más tarde',
      Tips3: 'Por favor, introduzca su correo electrónico válido',
      Tips4: 'Las dos contraseñas son inconsistentes.',
      PleaseEnter: 'Por favor escribe',
      Tips5: 'El formato del buzón es incorrecto.'
    },
    Mobile: {
      SelectPaymentMethod: {
        CustomizedService: 'Servicio Personalizado',
        Tags: 'Etiquetas',
        Tips1: 'Paquete (Próximamente)',
        Tips2: 'Bolsas (Próximamente)'
      },
      SearchBar: {
        SearchingFor: 'Buscando'
      },
      Header: {
        BackToShopping: 'De vuelta a las compras'
      },
      AddressDialog: {
        FullName: 'Nombre completo',
        PhoneNumber: 'Número de teléfono',
        StreetAddressLine1: 'Dirección de calle Linea 1',
        StreetAddressLine2: 'Dirección de calle Linea 2',
        City: 'Ciudad',
        StateProvinceRegion: 'Estado / Provincia / Región',
        ZipCode: 'Código postal',
        VAT: 'VAT',
        IOSS: 'IOSS'
      }
    },
    Common: {
      UpgradeBox: {
        Tips1: 'Se está procesando la actualización del sistema',
        OK: 'OK'
      }
    }
  }
}
